var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginFacebookActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.164 24.836 0 16 0C7.164 0 0 7.164 0 16C0 23.986 5.85 30.606 13.5 31.806V20.626H9.438V16H13.5V12.476C13.5 8.466 15.888 6.25 19.544 6.25C21.294 6.25 23.126 6.562 23.126 6.562V10.5H21.108C19.12 10.5 18.5 11.734 18.5 12.998V16H22.938L22.228 20.626H18.5V31.806C26.15 30.606 32 23.986 32 16Z",
    fill: "url(#paint0_linear_1722_5860)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9375 16H18.4995V12.998C18.4995 11.732 19.1195 10.5 21.1075 10.5H23.1255V6.562C23.1255 6.562 21.2935 6.25 19.5435 6.25C15.8875 6.25 13.4995 8.466 13.4995 12.476V16H9.4375V20.626H13.4995V31.806C14.3135 31.934 15.1495 32 15.9995 32C16.8495 32 17.6855 31.934 18.4995 31.806V20.626H22.2275L22.9375 16Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1722_5860",
    x1: 16,
    y1: 31.8056,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1569CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29AEF3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFacebookActive);
export default __webpack_public_path__ + "static/media/login-facebook-active.b5c699065819055a839d111adbe6a2a7.svg";
export { ForwardRef as ReactComponent };